import React, { useEffect, useState } from "react";
import { useIframeResizer } from "../hooks/useIframeResizer";

const EmbedForm = () => {
    const iframeRef = useIframeResizer({
        defaultHeight: 500,
        minHeight: 150,
        maxHeight: 2500
    });

    const [currentTextIndex, setCurrentTextIndex] = useState(0);

    const rotatingTexts = [
        "Le détail des programmes (Bachelor & MBA)",
        "Les opportunités internationales",
        "Les débouchés métiers dans l'hôtellerie et le tourisme",
        "Les conditions d'admission et frais de scolarité"
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTextIndex((prevIndex) => (prevIndex + 1) % rotatingTexts.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [rotatingTexts.length]);

    useEffect(() => {
        // Initialiser le dataLayer pour GTM
        window.dataLayer = window.dataLayer || [];

        // Gestionnaire d'événements pour les messages de l'iframe
        const handleMessage = (event) => {
            // Vérifier que le message vient de notre iframe
            if (event.source !== iframeRef.current?.contentWindow) return;

            // 1. Événements GTM - Pousser dans le dataLayer pour que GTM les traite
            if (event.data.type === 'GTM_EVENT' && event.data.payload) {
                window.dataLayer.push({
                    ...event.data.payload,
                    page_title: document.title,
                    page_url: window.location.href,
                    referrer: document.referrer
                });
            }

            // 2. Scroll vers le haut
            if (event.data.type === 'scrollToTop' || event.data.type === 'SCROLL_TO_TOP') {
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        };

        window.addEventListener('message', handleMessage);

        // Cleanup
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [iframeRef]);

    // Récupére les paramètres de l'URL actuelle
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);
    // URL de l'iframe avec les paramètres de l'URL actuelle
    const iframeUrl = `${process.env.REACT_APP_FORM_URL}?formation=management${searchParams.toString() ? '&' + searchParams.toString() : ''}`;

    return (
        <div id="brochure" className="EmbedForm-area bg-[url('../images/all-img/section-bg-1.png')] bg-cover bg-no-repeat bg-center section-padding">
            <div className="container">
                <div className="text-center">
                    <div className="mini-title">Brochure Vatel</div>
                    <div className="column-title tw-max-w-3xl tw-mx-auto tw-leading-tight">
                        Demandez votre brochure en <span className="shape-bg">1 minute</span> !
                    </div>
                </div>
                <div className="mt-8 mb-8 lg:tw-mb-0 text-center">
                    <h3 className="tw-text-sm lg:tw-text-xl font-semibold mb-2">Que trouverez-vous dans la brochure ?</h3>
                    <div className="text-rotator">
                        {rotatingTexts.map((text, index) => (
                            <div
                                key={index}
                                className={`rotating-text text-secondary font-bold text-2xl lg:tw-text-3xl ${
                                    index === currentTextIndex ? 'active' : ''
                                }`}
                            >
                                {text}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="lg:pt-10">
                    <div className="bg-white shadow-box rounded-[8px] p-2 lg:p-10 group hover:bg-primary">
                        <iframe
                            ref={iframeRef}
                            className="rounded-[8px] tw--overscroll-none"
                            src={iframeUrl}
                            style={{
                                width: '100%',
                                border: 'none',
                                overflow: 'hidden'
                            }}
                            title="Formulaire Brochure"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmbedForm;